/* eslint-disable @typescript-eslint/no-explicit-any */
// The whole code is copied from VPC.
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { TabStyles } from '@tableau/widgets';
import { CommonStyles, cssClass, fillStyle } from '../../../common/styles/CommonStyles';

const cssPrefix = 'ListView';

export namespace ListViewStyles {
  export const LIST_VIEW_ROW_OUTER_HEIGHT = 44;

  export const ListView = cssClass(cssPrefix, fillStyle, {
    fontWeight: 'normal',
    // We want a small "margin" above the list view header. To do this, use the fillStyle
    // (absolute positioning) and a positive "top" value.
    // We can't use margin-top / height 100% because it'll move everything down and show
    // an extra scroll bar
    top: 12,
    fontSize: 14,
    color: TabStyles.Typography.Color.Primary,
    $nest: {
      [`.tb-react-dg-hcell`]: {
        fontSize: 12,
        color: TabStyles.Typography.Color.PrimaryLight,
      },
      ['.tb-checkbox-cell']: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: LIST_VIEW_ROW_OUTER_HEIGHT,
        width: LIST_VIEW_ROW_OUTER_HEIGHT,
        paddingBottom: 0,
        paddingTop: 0,
        paddingLeft: 0,
        paddingRight: 0,
      },
      ['.tb-data-grid-icon']: {
        height: (LIST_VIEW_ROW_OUTER_HEIGHT + 'px !important') as any,
        marginTop: -2,
      },
      ['.tb-favorite-button-cell']: {
        width: LIST_VIEW_ROW_OUTER_HEIGHT,
        height: LIST_VIEW_ROW_OUTER_HEIGHT,
        lineHeight: LIST_VIEW_ROW_OUTER_HEIGHT,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
  });

  export const DataGridBodyTopBorder = cssClass(cssPrefix + '-data-grid-body-top-border', {
    $nest: {
      '.tb-react-dg-body': {
        borderTop: `1px solid ${CommonStyles.Colors.DividerLineColor}`,
      },
    },
  });

  export const ContentTypeCellContainer = cssClass(cssPrefix + '-content-type-cell-container', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: LIST_VIEW_ROW_OUTER_HEIGHT,
    paddingRight: 6,
  });

  export const ContentTypeCellImg = cssClass(cssPrefix + '-content-type-cell-img', {
    height: 18,
    width: 18,
  });

  export const iconStyle = { height: '17px', paddingRight: TabStyles.Spacing.DefaultSpace };
  export const listViewIconStyle = { ...iconStyle, flexShrink: 0, paddingBottom: TabStyles.Spacing.SmallSpace };
  export const listViewAfterIconStyle = {
    ...iconStyle,
    flexShrink: 0,
    paddingBottom: TabStyles.Spacing.SmallSpace,
    paddingLeft: TabStyles.Spacing.DefaultSpace,
  };

  export const GreyedOutTextStyle: React.CSSProperties = {
    color: '#BFBFBF',
    fontWeight: 'inherit',
  };

  export const HiddenUserStyle: React.CSSProperties = {
    ...GreyedOutTextStyle,
  };
}
